import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Image from "next/image";
import P1 from "@/public/static/images/process/p-1.png";
import P2 from "@/public/static/images/process/p-2.png";
import P3 from "@/public/static/images/process/p-3.png";
import P5 from "@/public/static/images/process/p-5.png";
import P7 from "@/public/static/images/process/p-7.png";
import P18 from "@/public/static/images/process/p-18.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  height: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0,
};

function Stamping() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [image, setImage] = React.useState<any>(null);
  const [productName, setProductName] = React.useState<string | null>(null);

  return (
    <div className="row">
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P1);
              setProductName("カメラ外装");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P1}
                  alt="カメラ外装"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  カメラ外装
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ5052系</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      難易度の高い立体形状でも高度な絞りプレス技術により対応。顧客のハイエンドな製品群に対応。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P2);
              setProductName("車載照明ケース");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P2}
                  alt="車載照明ケース"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  車載照明ケース
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">ステンレス</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      板厚0.5mmを29mmの深さまでプレス。同業他社3社が対応不可だった形状を弊社で熱処理せず通常プレスで実現。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P3);
              setProductName("オーディオ筐体");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P3}
                  alt="オーディオ筐体"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  オーディオ筐体
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ押出形材</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      プレス、切削、カラーアルマイトまで一貫加工。開口部の穴ダレによる意匠面への影響をなくすため、押出型材の内部からプレス。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P5);
              setProductName("意匠プレス");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P5}
                  alt="意匠プレス"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  意匠プレス
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ、ステンレス等</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      様々な体裁をプレス金型で表現。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P7);
              setProductName("ナット");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P7}
                  alt="ナット"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  ナット
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">ステンレス　板厚1.0mm</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      1枚の板から円筒形状を両方向へプレス。鍛造プレス機ではなく通常プレス機で難形状を実現。
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P18);
              setProductName("カメラ筐体");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P18}
                  alt="カメラ筐体"
                  className="card-img"
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  カメラ筐体
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ5052系</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      難形状をアルミ板から絞りプレス
                      プレスと切削の組み合わせでエッジ感を演出
                      高品位アルマイト着色
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-inner">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            className="close-btn"
          >
            <CloseIcon />
          </IconButton>
          <Image
            src={image}
            alt="Camera housing"
            className="card-img"
            loading="lazy"
          />
          <Typography
            id="modal-modal-title"
            className="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {productName}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

export default Stamping;
